import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import NotFound from "./404";
import TemplateForm from "./Template-form";

const CreateTemplate = () => {
  const { template_id } = useParams();
  console.log(template_id);
  const [templateDetail, setTemplateDetail] = useState();
  const { sendRequest } = useHttp();
  const user_roles = useSelector((state) => state.auth.roles);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(authActions.setLoaderStatus({ status: true }));
    if (template_id) {
      document.title = `Edit Template`;
      sendRequest(
        {
          url: endPoints.getTemplate + "/" + template_id,
          method: "GET",
        },
        (response) => {
          console.log(response.id);
          if (response.id) {
            // setTemplateDetail("Hello");
            setTemplateDetail(response);
          }
          dispatch(authActions.setLoaderStatus({ status: false }));
        }
      );
    } else {
      document.title = `Create Template`;
      dispatch(authActions.setLoaderStatus({ status: false }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template_id]);
  return (
    <>
      {user_roles.role_id === 1 ? (
        <NotFound />
      ) : (
        <section className="mid_wrap">
          <div className="container">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb mb-4 pb-2">
                <li className="breadcrumb-item">
                  <Link to="/">Dashboard</Link>
                </li>
                <li className="breadcrumb-item " aria-current="page">
                  <Link to="/alltemplates">All Templates</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Create New Template
                </li>
              </ol>
            </nav>
            <div className="row d-flex justify-content-center ">
              <div className="col-md-8 ">
                <div className="bx_a">
                  <TemplateForm templateDetail={templateDetail} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CreateTemplate;
